

import React, { useEffect, useState } from "react"
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Image,
  Alert,
  User,
  Avatar,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBuildingCircleXmark, faBuildingLock, faCode, faCommentDots, faEllipsis, faEye, faEyeSlash, faGem, faIdBadge, faInfo, faTableCellsRowUnlock, faUnlock, faUser, faUserTag } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css

import { apiRoute, ENUM_USER_TYPE, linksUrl } from "../constants/enum.js"
import { setLogin, setLogout } from "../state/authSlice.jsx"
import { usePost, usePostLogin, usePostMutateWithSuccess } from "../api/reactQueryCustomHooks.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { resetCompCode } from "../state/companySlice.jsx"
import { isMobile } from "react-device-detect"


export default function App() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)


  const [formData, setFormData] = useState({
    clientCode: "",
    loginName: "",
    password: "",
  })

  const [errors, setErrors] = useState({})

  const resetValues = () => {
    setFormData({
      clientCode: "",
      loginName: "",
      password: "",
    })
  }
  const FixUserMenu = [
    {
      "menuid": 3245,
      "menuname": "sale_order_entry",
      "menuparentid": null,
      "level": "1",
      "controller": "SaleOrderEntry"
    },
    {
      "menuid": 3259,
      "menuname": "Master",
      "menuparentid": null,
      "level": "1",
      "controller": null
    },
    {
      "menuid": 3260,
      "menuname": "account_entry",
      "menuparentid": null,
      "level": "1",
      "controller": "AccountEntry"
    },
    {
      "menuid": 3241,
      "menuname": "company",
      "menuparentid": null,
      "level": "1",
      "controller": "Companies"
    },
    {
      "menuid": 3295,
      "menuname": "dashboard",
      "menuparentid": null,
      "level": "1",
      "controller": "Dashboard"
    },

  ]

  const FixDistMenu = [
    // {
    //   "menuid": 3296,
    //   "menuname": "purchase_order_entry",
    //   "menuparentid": null,
    //   "level": "1",
    //   "controller": "PurchaseOrderEntry"
    // },
    {
      "menuid": 3245,
      "menuname": "sale_order_entry",
      "menuparentid": null,
      "level": "1",
      "controller": "SaleOrderEntry"
    },
    {
      "menuid": 3241,
      "menuname": "company",
      "menuparentid": null,
      "level": "1",
      "controller": "Companies"
    },
    {
      "menuid": 3295,
      "menuname": "dashboard",
      "menuparentid": null,
      "level": "1",
      "controller": "Dashboard"
    },
  ]


  const onSuccessTasks = (data) => {
    console.log(data)
    if (data && Object.keys(data)?.length > 0) {
      if (data && Object.keys(data).length > 0) {
        if (data.user.isActive == 0) {
          toast.error("You  Are not Active Please Contact Admin", {
            "position": "top-center"
          })
          return
        }
        else {
          navigate(linksUrl.dashboard)
          dispatch(
            setLogin({
              user: data.user,
              token: data.accessToken,
              menu: { appMenu: data.appMenu, userMenu: data?.user?.isadmin == 1 ? data.userMenu : data?.user?.userType == ENUM_USER_TYPE.DISTRIBUTOR ? FixDistMenu : FixUserMenu },
              isAuthenticated: true,
              userSetting: data.userSetting
            })
          )
          dispatch(resetCompCode())
        }
      }


      queryClient.removeQueries()

    }
    else {
      toast.error("Incorrect Details...", {
        "position": "top-center"
      })
    }


  }

  const { isPending, mutate: login } = usePostLogin({
    url: "/user/login",
    queryKey: "auth",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    let msg = ''
    if (formData.clientCode.trim() === "") {
      msg = " Client Code required , "
    }
    if (formData.loginName.trim() === "") {
      msg += " Login Name required , "
    }
    if (formData.password.trim() === "") {
      msg += " Password required , "
    }
    return msg
  }


  const handleSubmit = (e) => {
    e.preventDefault()
    let errorMsg = validateForm()


    if (errorMsg.trim() == "") {
      login({
        data: {
          Client_Code: formData.clientCode,
          LoginName: formData.loginName,
          Password: formData.password,
        },
      })
    }
    else {
      toast.error(errorMsg, { "position": "top-center" })
    }

  }

  return (
    <div>
      <ToastContainer />
      {/* //bg-gradient-to-tr from-gray-50 to-white */}
      <div className={`${isMobile ? "   bg-gradient-to-bl from-white to-slate-200 border-t-4 border-red-700" : "bg-white border-t-4"} h-screen`}>

        <div className={` ${isMobile ? "w-full" : "w-2/5"} text-center mx-auto  flex flex-col bg-gradient-to-bl from-white to-pink-50 rounded-b-full `} >
          <img className="mx-auto rounded-xl h-auto" height="50px" src="posicon.jpg" alt="POS" />
          <h2 className="font-semibold tracking-widest text-2xl text-red-600">POS</h2>
        </div>
        <div className={` ${isMobile ? " py-0 px-3" : "py-0 px-1"} "min-h-screen flex flex-col items-center justify-start  text-baseline"`}>
          <div className={`${isMobile ? " border-1" : "border-1"} " shadow-2xl
            shadow-red-200 rounded-xl max-w-md w-full  pt-3 pb-10 px-6    m-5
           bg-gradient-to-b from-white to-gray-100`}>
            {/* //bg-custome-login-box-color">  border-radius */}
            <div className="mx-auto  
           border-b-0 border-gray-300 border-x-pink-200">
              <h2 className="font-bold text-xl text-center">LOGIN</h2>
            </div>
            <form onSubmit={handleSubmit} autoComplete='off'>
              <div className="!mt-10">
                <Input
                  isRequired
                  type="text"
                  label="Client Code"
                  placeholder="Enter Client Code "
                  size="md"
                  labelPlacement="outside"
                  name="clientCode"
                  value={formData.clientCode}
                  variant="light"
                  startContent={<FontAwesomeIcon className="text-red-400" icon={faBuildingLock}></FontAwesomeIcon>}

                  onChange={handleChange}
                  classNames={{
                    inputWrapper: " border-1 border-gray-400 bg-gray-50 rounded-full",
                    label: "uppercase text-xs  font-semibold",
                    //base:"text-red-700"
                    // input:" "

                  }}
                  isDisabled={isPending}
                />
              </div>
              <div className="!mt-10">
                <Input
                  isRequired
                  type="text"
                  label="Login Name"
                  placeholder="Entry Login Name "
                  labelPlacement="outside"
                  name="loginName"
                  radius="none"
                  value={formData.loginName}
                  startContent={<FontAwesomeIcon className="text-red-400" icon={faUserTag}></FontAwesomeIcon>}
                  onChange={handleChange}
                  variant="light"
                  classNames={{
                    inputWrapper: "border-1 border-gray-400 bg-gray-50  rounded-full",
                    label: "uppercase text-xs font-semibold"
                  }}
                  isDisabled={isPending}
                  size="md"

                />
              </div>
              <div className="!mt-10">
                <Input
                  isRequired
                  label="Password"
                  labelPlacement="outside"
                  placeholder="Enter your password"
                  name="password"
                  size="md"
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}

                  startContent={<FontAwesomeIcon className="text-red-400" icon={faTableCellsRowUnlock}></FontAwesomeIcon>}
                  variant="light"
                  classNames={{
                    inputWrapper: "border-1 border-gray-400 bg-gray-50  rounded-full",
                    label: "uppercase text-xs font-semibold"
                  }}
                  endContent={
                    <button
                      className="focus:outline-none"
                      size="sm"
                      type="button"
                      variant="light"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}

                />
              </div>

              <div className="!mt-10 text-center">

                <Button variant="flat" radius="none"
                  className="  text-md uppercase  rounded-full tracking-widest text-white  w-full  border-0 border-slate-700
                  bg-gradient-to-t from-red-600 to-red-700" type="submit" isLoading={isPending}>
                  Login
                </Button>
              </div>
            </form>
          </div>
        </div>
        <div className="mx-auto">
          <div className={` ${isMobile ? "w-full" : "w-full"} p-1  fixed bottom-0 text-center mx-auto mt-2 flex flex-col bg-gradient-to-t from-white to-pink-50 rounded-t-full `} >
            <div className=" mx-auto flex gap-5 justify-start items-center">
              <img src="IITS_Logo.png" width="30px" alt="INTITS" className="ml-10" ></img>
              <h2 className="font-semibold  tracking-widest text-xs" >Integrated It Solution</h2>
            </div>
          </div>
        </div>
      </div>

    </div>

  )
}
